import {Component, Inject, OnInit, Optional} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';
import {Utils} from 'src/app/shared/utils/utils';

@Component({
  selector: 'app-adding-modal',
  templateUrl: './adding-modal.component.html',
  styleUrls: ['./adding-modal.component.scss'],
})
export class AddingModalComponent implements OnInit {
  header = '';
  form!: UntypedFormGroup;
  isFieldInvalid = Utils.isFieldInvalid;

  constructor(
    private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: string
  ) {}

  ngOnInit(): void {
    this.header = this.data;
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl('', [
        Validators.required,
        Validators.maxLength(20),
      ]),
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  saveData(): void {
    this.form.invalid
      ? Utils.validateAllFormFields(this.form)
      : this.dialogRef.close(this.form.value.name);
  }
}
